import { Link } from "react-router";
import { SiteCopy } from "../copy";
import { ROUTES } from "../links";
import { ActionReel } from "../widgets/ActionReel";
import { DeskPreview } from "../widgets/DeskPreview";
import { MapRoute } from "../widgets/MapRoute";
import { PrioritiesDemo } from "../widgets/PrioritiesDemo";
import { RoutesPanel } from "../widgets/RoutesPanel";
import { ScrollStory } from "../widgets/ScrollStory";
import { usePageTitle } from "./usePageTitle";
import { PageFaq } from "../widgets/PageFaq";

/**
 * The homepage (the prototype's `#site .spage[data-s="home"]`). Dawn (v33): night in the story,
 * pre-dawn under the horizon at "See what Abi can do" (`dawn-l1`), daybreak at "Inside Abi"
 * (`dawn-l2`, where the reel and the priorities demo stay dark), morning from the employer door
 * (`dawn-l3`) through the footer.
 */
export function HomePage() {
  usePageTitle(null);
  return (
    <div className="spage on" data-s="home">
      <ScrollStory skipTo="seewhat" />

      {/* See what Abi can do: the app at reduced scale */}
      <section className="band stdark dawn dawn-l1" id="seewhat">
        <div className="wrap">
          <div className="shead">
            <SiteCopy as="h2" k="home.desk.h2" />
            <SiteCopy as="p" k="home.desk.p" />
          </div>
          <DeskPreview />
          <SiteCopy as="p" className="mmini-note" k="home.desk.note" />
          <div className="ctarow">
            <Link className="sbtn p big" to={ROUTES.start}>
              <SiteCopy k="cta.start" />
            </Link>
            <SiteCopy k="home.desk.ctanote" />
          </div>
        </div>
      </section>

      {/* Inside Abi */}
      <section className="band stdark dawn dawn-l2" id="inside">
        <div className="wrap">
          <div className="shead">
            <SiteCopy as="h2" k="home.inside.h2" />
            <SiteCopy as="p" k="home.inside.p" />
          </div>

          <div className="stwide">
            <SiteCopy as="h3" k="home.inside.r4h" />
            <SiteCopy as="p" className="stwide-p" k="home.inside.r4p" />
            <MapRoute />
          </div>

          <div className="stwide dark">
            <SiteCopy as="h3" k="home.inside.r1h" />
            <SiteCopy as="p" className="stwide-p" k="home.inside.r1p" />
            <div className="pribar">
              <div className="pribar-head">
                <span className="dot" />
                <SiteCopy as="b" k="home.pri.demo" />
              </div>
              <SiteCopy as="p" className="pvsurp" k="home.pri.surplus" />
              <PrioritiesDemo />
              <SiteCopy as="p" className="pvhint" k="home.pri.hint" />
            </div>
          </div>

          <div className="strow flip">
            <div className="stxt">
              <SiteCopy as="h3" k="home.inside.r3h" />
              <SiteCopy as="p" k="home.inside.r3p" />
            </div>
            <ActionReel />
          </div>
          <div className="strow">
            <div className="stxt">
              <SiteCopy as="h3" k="home.inside.r2h" />
              <SiteCopy as="p" k="home.inside.r2p" />
            </div>
            <div className="st-panel routes">
              <RoutesPanel />
              <SiteCopy as="p" className="tagnote" k="home.inside.r2note" />
            </div>
          </div>
        </div>
      </section>

      {/* the employer door */}
      <Link className="empdoor dawn dawn-l3" to={ROUTES.employers}>
        <div className="wrap">
          <SiteCopy k="emp.door2" />
          <b>
            See how it works for teams <span aria-hidden="true">&rarr;</span>
          </b>
        </div>
      </Link>
      <PageFaq page="home" />
    </div>
  );
}
